import Vue from 'vue';
import Vuex from 'vuex';
import jwt from 'jsonwebtoken';
import axios from 'axios';
import _auth from '../api/_auth';

const api = {
  auth: _auth,
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticating: false,
    authenticationError: null,
    user: {
      id: null,
      access_token: null,
      token_type: null,
      expires_in: null,
    },

    orderNotifications: null,
  },
  mutations: {
    setUser(state, payload) { state.user = payload; },
    clearUser(state) { state.user = null; },
    setAuthenticationError(state, payload) { state.authenticationError = payload; },
    clearForAuthentication(state) {
      state.authenticationError = null;
      state.user = {
        id: null,
        access_token: null,
        token_type: null,
        expires_in: null,
      };
    },
    setIsAuthenticating(state, payload) { state.isAuthenticating = payload; },

    setNotifications(state, payload) {
      console.log('');
      const NOTIFICATIONS_BY_ORDERS = {};
      payload.forEach((noti) => {
        // noti is unread
        if (noti.read === 0) {
          const {
            id: notiId,
            order_id: orderId,
          } = noti;

          if (!NOTIFICATIONS_BY_ORDERS[orderId]) {
            NOTIFICATIONS_BY_ORDERS[orderId] = {
              notifications: [],
            };
          }
          NOTIFICATIONS_BY_ORDERS[orderId].notifications.push(notiId);
        }
      });
      state.orderNotifications = NOTIFICATIONS_BY_ORDERS;
    },

    removeUnreadNotification(state, payload) {
      const { orderId, notiId } = payload;

      const orderNoti = state.orderNotifications[orderId];
      console.log(payload);
      console.log(state.orderNotifications[orderId]);
      if (orderNoti) {
        orderNoti.notifications = orderNoti.notifications.filter(
          (item) => {
            console.log(item);
            console.log(`${item} !== ${notiId}`);
            return item !== notiId;
          },
        );

        if (orderNoti.notifications.length === 0) {
          state.orderNotifications[orderId] = undefined;
        }
      }

      console.log(`Noti #${payload.notiId} is removed`);
      console.log(state.orderNotifications);
    },
  },
  actions: {
    async logout({ commit }) {
      try {
        commit('clearForAuthentication');
        localStorage.removeItem('user');
        await api.auth.logout();
        axios.defaults.headers.common.Authorization = '';
      } catch (e) {
        console.error(e);
      }
    },
    // TODO: implement JWT standard when logged in, and resume session
    async login({ commit, dispatch }, payload) {
      commit('clearForAuthentication');
      commit('setIsAuthenticating', true);
      try {
        const res = await api.auth.login(
          payload.username,
          payload.password,
          payload.token,
        );
        if (res.status === 200) {
          dispatch('storeUser', res.data);
        }
      } catch (e) {
        commit('setAuthenticationError', e);
      } finally {
        commit('setIsAuthenticating', false);
      }
    },
    async storeUser({ dispatch }, payload) {
      const decoded = jwt.decode(payload.access_token);
      const res = {
        id: decoded.sub,
        ...payload,
      };
      localStorage.setItem('user', JSON.stringify(res));
      dispatch('storeUserInVuex', res);
    },
    async storeUserInVuex({ commit, getters }, payload) {
      commit('setUser', payload);

      window.SessionStack.identify({
        userId: payload.id,
      });

      axios.defaults.headers.common.Authorization = getters.authenticationHeader;
    },
    async obtainStoredUser({ dispatch }) {
      if (localStorage.getItem('user')) {
        dispatch('storeUserInVuex', JSON.parse(localStorage.getItem('user')));
      }
    },
    async vuexInitial({ dispatch }) {
      console.log('vuex initial');
      dispatch('obtainStoredUser');
    },
  },
  getters: {
    isAuthenticating: state => state.isAuthenticating,
    isAuthenticated: state => state.user.id !== null,
    authenticationError: state => state.authenticationError,
    user: state => state.user,
    authenticationHeader: state => `Bearer ${state.user.access_token}`,

    orderNotifications: state => state.orderNotifications,
  },
});
